import * as mutationType from "../mutation_types";

const state = {
  company: {},
  coreValues: [],
  edit_corevalue: {},
  corevalue_activities: [],
  missionstatement_activities: [],
  corevalue_actions: {},
  strategic_anchors: [],
  business_metrics: [],
  business_metric_items: [],
  custom_fields: []
};

const getters = {
  company: state => state.company,
  coreValues: state => state.coreValues,
  survey_link_list: state => {
    let list = [
      { id: "", name: "None" },
      { id: "mission", name: "Mission" }
    ];
    return list.concat(state.coreValues);
  },
  edit_corevalue: state => state.edit_corevalue,
  corevalue_activities: state => state.corevalue_activities,
  missionstatement_activities: state => state.missionstatement_activities,
  mission_statement: state => state.company.missionStatement || "",
  corevalue_actions: state => state.corevalue_actions,
  strategic_anchors: state => state.strategic_anchors,
  business_metrics: state => state.business_metrics,
  business_metric_items: state => state.business_metric_items,
  custom_fields: state => state.custom_fields
};

const actions = {
  getCompany({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get("/api/company")
        .then(res => {
          commit(mutationType.SET_COMPANY, res.data);
          resolve(res.data.id);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  saveCompany({ commit }, company) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post("/api/company", company)
        .then(res => {
          company.id = res.data;
          commit(mutationType.SET_COMPANY, company);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  uploadLogo({ commit }, file) {
    return new Promise((resolve, reject) => {
      let formData = new FormData();
      formData.append("file", file.file);
      this._vm.$http
        .post("/api/company/logo", formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(res => {
          commit(mutationType.SET_COMPANY_LOGO, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  getCoreValues({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get("/api/company/corevalues")
        .then(res => {
          commit(mutationType.SET_COMPANY_CORE_VALUES, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  getCoreValue({ commit }, id) {
    return new Promise((resolve, reject) => {
      if (id == "0") {
        commit(mutationType.SET_COMPANY_EDIT_CORE_VALUE, {});
        resolve();
      } else {
        this._vm.$http
          .get("/api/company/corevalues/" + id)
          .then(res => {
            commit(mutationType.SET_COMPANY_EDIT_CORE_VALUE, res.data);
            resolve();
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      }
    });
  },
  saveCoreValues({ commit }, coreValues) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post("/api/company/corevalues", coreValues)
        .then(res => {
          commit(mutationType.SET_COMPANY_CORE_VALUES, res.data);
          commit(
            `profile/${mutationType.SET_PROFILE_SETTINGS_CORE_VALUES}`,
            res.data,
            {
              root: true
            }
          );
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  deleteCoreValue({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .delete("/api/company/corevalues/" + id)
        .then(() => {
          commit(mutationType.DELETE_COMPANY_CORE_VALUE, id);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  saveMissionStatement({ commit }, missionStatement) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post("/api/company", missionStatement)
        .then(() => {
          commit(mutationType.SET_COMPANY_MISSION_STATEMENT, missionStatement);
          commit(
            `profile/${mutationType.SET_PROFILE_SETTINGS_MISSION_STATEMENT}`,
            missionStatement,
            {
              root: true
            }
          );
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  getCoreValueActivities({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get("/api/company/corevalues/" + id + "/activities")
        .then(res => {
          commit(mutationType.SET_CORE_VALUE_ACTIVITES, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  getMissionStatementActivities({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get("/api/company/mission/activities")
        .then(res => {
          commit(mutationType.SET_MISSION_STATEMENT_ACTIVITES, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  getCoreValueActions({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get(`/api/company/${id ? "corevalues/" + id : "mission"}/actions`)
        .then(res => {
          commit(mutationType.SET_CORE_VALUE_ACTIONS, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  getStrategicAnchors({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get("/api/company/anchors")
        .then(res => {
          commit(mutationType.SET_COMPANY_STRATEGIC_ANCHORS, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  saveStrategicAnchors({ commit }, anchors) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post("/api/company/anchors", anchors)
        .then(res => {
          commit(mutationType.SET_COMPANY_STRATEGIC_ANCHORS, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  completeStrategicAnchor({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put("/api/company/anchors/" + id)
        .then(() => {
          commit(mutationType.DELETE_COMPANY_STRATEGIC_ANCHOR, id);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  deleteStrategicAnchor({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .delete("/api/company/anchors/" + id)
        .then(() => {
          commit(mutationType.DELETE_COMPANY_STRATEGIC_ANCHOR, id);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  getBusinessMetrics({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get("/api/company/metrics")
        .then(res => {
          commit(mutationType.SET_COMPANY_BUSINESS_METRICS, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  saveBusinessMetric({ commit }, metrics) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post("/api/company/metrics", metrics)
        .then(res => {
          commit(mutationType.SET_COMPANY_BUSINESS_METRIC, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  deleteBusinessMetric({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .delete("/api/company/metrics/" + id)
        .then(() => {
          commit(mutationType.DELETE_COMPANY_BUSINESS_METRIC, id);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  getBusinessMetricItems({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get(`/api/company/metrics/${id}/items`)
        .then(res => {
          commit(mutationType.SET_COMPANY_BUSINESS_METRIC_ITEMS, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  saveBusinessMetricItem({ commit }, item) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post(`/api/company/metrics/${item.businessMetricId}/items`, item)
        .then(res => {
          commit(mutationType.SET_COMPANY_BUSINESS_METRIC_ITEM, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  deleteBusinessMetricItem({ commit }, item) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .delete(
          `/api/company/metrics/${item.businessMetricId}/items/${item.id}`
        )
        .then(() => {
          commit(mutationType.DELETE_COMPANY_BUSINESS_METRIC_ITEM, item.id);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  getCustomFields({ commit, state }) {
    return new Promise((resolve, reject) => {
      if (state.custom_fields.length > 0) {
        resolve();
      } else {
        this._vm.$http
          .get("/api/company/fields")
          .then(res => {
            commit(mutationType.SET_COMPANY_CUSTOM_FIELDS, res.data);
            resolve();
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      }
    });
  },
  saveCustomField({ commit }, metrics) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post("/api/company/fields", metrics)
        .then(res => {
          commit(mutationType.SET_COMPANY_CUSTOM_FIELD, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  deleteCustomField({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .delete("/api/company/fields/" + id)
        .then(() => {
          commit(mutationType.DELETE_COMPANY_CUSTOM_FIELD, id);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  }
};

const mutations = {
  [mutationType.SET_COMPANY](state, company) {
    if (!company) {
      company = {};
    }
    state.company = company;
  },
  [mutationType.SET_COMPANY_LOGO](state, url) {
    if (state.company) {
      state.company.logoUrl = url;
    }
  },
  [mutationType.SET_COMPANY_CORE_VALUES](state, coreValues) {
    state.coreValues = coreValues;
  },
  [mutationType.SET_COMPANY_EDIT_CORE_VALUE](state, coreValue) {
    state.edit_corevalue = coreValue;
  },
  [mutationType.SET_COMPANY_MISSION_STATEMENT](state, missionStatement) {
    state.company.missionStatement = missionStatement.missionStatement;
  },
  [mutationType.DELETE_COMPANY_CORE_VALUE](state, id) {
    let index = state.coreValues.findIndex(cv => cv.id == id);
    if (index >= 0) {
      state.coreValues.splice(index, 1);
    }
  },
  [mutationType.SET_CORE_VALUE_ACTIVITES](state, list) {
    state.corevalue_activities = list;
  },
  [mutationType.SET_MISSION_STATEMENT_ACTIVITES](state, list) {
    state.missionstatement_activities = list;
  },
  [mutationType.SET_CORE_VALUE_ACTIONS](state, actions) {
    state.corevalue_actions = actions;
  },
  [mutationType.SET_COMPANY_STRATEGIC_ANCHORS](state, list) {
    state.strategic_anchors = list;
  },
  [mutationType.DELETE_COMPANY_STRATEGIC_ANCHOR](state, id) {
    let index = state.strategic_anchors.findIndex(cv => cv.id == id);
    if (index >= 0) {
      state.strategic_anchors.splice(index, 1);
    }
  },
  [mutationType.SET_COMPANY_BUSINESS_METRICS](state, list) {
    state.business_metrics = list;
  },
  [mutationType.SET_COMPANY_BUSINESS_METRIC](state, obj) {
    let index = state.business_metrics.findIndex(cv => cv.id == obj.id);
    if (index >= 0) {
      state.business_metrics[index] = Object.assign(
        state.business_metrics[index],
        obj
      );
    } else {
      state.business_metrics.push(obj);
    }
  },
  [mutationType.DELETE_COMPANY_BUSINESS_METRIC](state, id) {
    let index = state.business_metrics.findIndex(cv => cv.id == id);
    if (index >= 0) {
      state.business_metrics.splice(index, 1);
    }
  },
  [mutationType.SET_COMPANY_BUSINESS_METRIC_ITEMS](state, list) {
    state.business_metric_items = list;
  },
  [mutationType.SET_COMPANY_BUSINESS_METRIC_ITEM](state, obj) {
    let index = state.business_metric_items.findIndex(cv => cv.id == obj.id);
    if (index >= 0) {
      state.business_metric_items[index] = Object.assign(
        state.business_metric_items[index],
        obj
      );
    } else {
      state.business_metric_items.unshift(obj);
    }
  },
  [mutationType.DELETE_COMPANY_BUSINESS_METRIC_ITEM](state, id) {
    let index = state.business_metric_items.findIndex(cv => cv.id == id);
    if (index >= 0) {
      state.business_metric_items.splice(index, 1);
    }
  },
  [mutationType.SET_COMPANY_CUSTOM_FIELDS](state, list) {
    state.custom_fields = list;
  },
  [mutationType.SET_COMPANY_CUSTOM_FIELD](state, obj) {
    let index = state.custom_fields.findIndex(cv => cv.id == obj.id);
    if (index >= 0) {
      state.custom_fields[index] = Object.assign(
        state.custom_fields[index],
        obj
      );
    } else {
      state.custom_fields.push(obj);
    }
  },
  [mutationType.DELETE_COMPANY_CUSTOM_FIELD](state, id) {
    let index = state.custom_fields.findIndex(cv => cv.id == id);
    if (index >= 0) {
      state.custom_fields.splice(index, 1);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
